"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "m-h-100"
  }, [_c("span", {
    staticClass: "m-flex"
  }, [_vm._t("label", function () {
    return [_vm._v(_vm._s(_vm.label))];
  }), _c("a-button", {
    staticClass: "m-m-v-8",
    attrs: {
      type: "link",
      size: "small"
    },
    on: {
      click: _vm.handleOpen
    }
  }, [_vm._v("+" + _vm._s(_vm.modalTitle))]), _vm.desc ? _c("span", {
    staticClass: "m-tips-color"
  }, [_vm._v(_vm._s(_vm.desc))]) : _vm._e()], 2), _c("a-form-model", {
    ref: "form",
    attrs: {
      layout: "inline",
      model: _vm.form
    }
  }, [_c("BasisTableLayout", {
    attrs: {
      "row-key": _vm.rowKey,
      "show-tool-btn": false,
      selectable: _vm.multiple,
      pagination: _vm.multiple ? "" : false,
      "empty-desc": "暂无数据",
      scroll: _vm.tableScroll,
      "data-source": _vm.form.dataSource,
      columns: _vm.listColumns,
      "cur-pagination": _vm.curPagination,
      "toolbar-style": {
        marginBottom: 0
      }
    },
    on: {
      "update:curPagination": function ($event) {
        _vm.curPagination = $event;
      },
      "update:cur-pagination": function ($event) {
        _vm.curPagination = $event;
      }
    },
    scopedSlots: _vm._u([_vm.multiple ? {
      key: "layoutToolbar",
      fn: function () {
        return [_c("div", {
          staticClass: "m-flex m-flex-1 m-m-b-4",
          staticStyle: {
            "line-height": "24px"
          }
        }, [_c("a-button", {
          attrs: {
            size: "small",
            disabled: _vm.selectedIds.length === 0,
            type: "danger"
          },
          on: {
            click: _vm.handleBatchDel
          }
        }, [_vm._v("批量删除")]), _vm._l(_vm.batchEditButtons, function (btn, index) {
          return _c("a-button", {
            key: index,
            attrs: {
              type: "primary",
              size: "small",
              disabled: _vm.selectedIds.length === 0
            },
            on: {
              click: function ($event) {
                return _vm.handleOpenEditModal(btn);
              }
            }
          }, [_vm._v(" " + _vm._s(btn.batchEditTitle || "批量修改" + btn.title) + " ")]);
        }), _vm.$scopedSlots.extra ? _c("span", {
          staticClass: "m-m-r-8"
        }, [_vm._t("extra")], 2) : _vm._e(), _vm.selectedIds.length > 0 ? [_vm._v("  当前选中 "), _c("span", {
          staticClass: "m-type-primary m-m-h-4"
        }, [_vm._v(_vm._s(_vm.selectedIds.length))]), _vm._v(" 条数据 ")] : _vm._e(), !_vm.valid ? _c("span", {
          staticClass: "m-m-l-8",
          staticStyle: {
            color: "red"
          }
        }, [_vm._v("请填写表格中的必填项")]) : _vm._e()], 2)];
      },
      proxy: true
    } : null, _vm._l(_vm.editableColumns, function (column) {
      return {
        key: column.dataIndex,
        fn: function ({
          record,
          index
        }) {
          return [_c("a-form-model-item", {
            key: `dataSource.${(_vm.curPagination.current - 1) * _vm.curPagination.pageSize + index}.${column.dataIndex}`,
            staticClass: "custom-form-item",
            attrs: {
              prop: `dataSource.${(_vm.curPagination.current - 1) * _vm.curPagination.pageSize + index}.${column.dataIndex}`,
              rules: {
                required: column.required === false ? false : true,
                message: column.message || "请输入",
                trigger: "blur"
              }
            }
          }, [!column.valueType || column.valueType === "input" ? _c("a-input", _vm._b({
            staticStyle: {
              width: "100%"
            },
            attrs: {
              size: "small"
            },
            on: {
              change: function ($event) {
                return _vm.debounceFieldChange(record, column.dataIndex);
              }
            },
            model: {
              value: record[column.dataIndex],
              callback: function ($$v) {
                _vm.$set(record, column.dataIndex, $$v);
              },
              expression: "record[column.dataIndex]"
            }
          }, "a-input", column.fieldProps, false)) : ["inputNumber", "AInputNumber"].includes(column.valueType) ? _c("a-input-number", _vm._b({
            staticStyle: {
              width: "100%"
            },
            attrs: {
              size: "small"
            },
            on: {
              change: function ($event) {
                return _vm.debounceFieldChange(record, column.dataIndex);
              }
            },
            model: {
              value: record[column.dataIndex],
              callback: function ($$v) {
                _vm.$set(record, column.dataIndex, $$v);
              },
              expression: "record[column.dataIndex]"
            }
          }, "a-input-number", _vm._.merge({
            max: 9999999999.99,
            precision: 2
          }, column.fieldProps || {}), false)) : _c(column.valueType, _vm._b({
            tag: "component",
            staticStyle: {
              width: "100%"
            },
            attrs: {
              size: "small"
            },
            on: {
              change: function ($event) {
                return _vm.debounceFieldChange(record, column.dataIndex);
              }
            },
            model: {
              value: record[column.dataIndex],
              callback: function ($$v) {
                _vm.$set(record, column.dataIndex, $$v);
              },
              expression: "record[column.dataIndex]"
            }
          }, "component", column.fieldProps, false))], 1)];
        }
      };
    }), {
      key: "operation",
      fn: function ({
        record
      }) {
        return [_c("a", {
          on: {
            click: function ($event) {
              return _vm.handleDel(record[_vm.rowKey]);
            }
          }
        }, [_vm._v("删除")])];
      }
    }], null, true),
    model: {
      value: _vm.selectedIds,
      callback: function ($$v) {
        _vm.selectedIds = $$v;
      },
      expression: "selectedIds"
    }
  })], 1), _c("BasisModal", {
    attrs: {
      "after-close": _vm.afterClose,
      size: "lg"
    },
    on: {
      ok: _vm.confirmSelectedResult
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c("div", {
          staticClass: "m-flex"
        }, [_c("span", [_vm._v(_vm._s(_vm.modalTitle))]), _vm.multiple ? _c("span", {
          staticClass: "m-tips-color m-m-l-16 m-fw-normal m-flex"
        }, [_vm._v(" 共选择 "), _c("span", {
          staticClass: "m-type-primary m-m-h-4"
        }, [_vm._v(_vm._s(_vm.selectedRowKeys.length))]), _vm._v(" 条数据 ")]) : _vm._e()])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("BasisTableLayout", {
    ref: "basisTableLayout",
    attrs: {
      "show-tool-btn": false,
      "row-key": _vm.rowKey,
      selectable: true,
      multiple: _vm.multiple,
      scroll: {
        x: false,
        y: `calc(60vh - 100px)`
      },
      columns: _vm.modalColumns,
      "default-selected-row-keys": _vm.curSelectedRowKeys,
      "default-selected-rows": _vm.form.dataSource,
      params: _vm.params,
      method: _vm.method
    },
    on: {
      rowSelectionChange: _vm.handleRowSelectionChange
    }
  })], 1), _c("BasisModal", {
    attrs: {
      title: _vm.curEditData.batchEditTitle || `批量修改${_vm.curEditData.title}`
    },
    on: {
      ok: _vm.handleBatchEdit
    },
    model: {
      value: _vm.batchEditVisible,
      callback: function ($$v) {
        _vm.batchEditVisible = $$v;
      },
      expression: "batchEditVisible"
    }
  }, [_c("a-form-model", {
    ref: "editForm",
    attrs: {
      layout: "horizontal",
      model: _vm.editForm
    }
  }, [_c("a-form-model-item", {
    attrs: {
      rules: [{
        required: _vm.curEditData.required === false ? false : true,
        message: _vm.curEditData.message || "请输入",
        trigger: "change"
      }],
      label: _vm.curEditData.title,
      prop: _vm.curEditData.dataIndex
    }
  }, [!_vm.curEditData.valueType || _vm.curEditData.valueType === "input" ? _c("a-input", _vm._b({
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.curEditData.placeholder || "请输入" + _vm.curEditData.title
    },
    model: {
      value: _vm.editForm[_vm.curEditData.dataIndex],
      callback: function ($$v) {
        _vm.$set(_vm.editForm, _vm.curEditData.dataIndex, $$v);
      },
      expression: "editForm[curEditData.dataIndex]"
    }
  }, "a-input", _vm.curEditData.fieldProps, false)) : ["inputNumber", "AInputNumber"].includes(_vm.curEditData.valueType) ? _c("a-input-number", _vm._b({
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.curEditData.placeholder || "请输入" + _vm.curEditData.title
    },
    model: {
      value: _vm.editForm[_vm.curEditData.dataIndex],
      callback: function ($$v) {
        _vm.$set(_vm.editForm, _vm.curEditData.dataIndex, $$v);
      },
      expression: "editForm[curEditData.dataIndex]"
    }
  }, "a-input-number", _vm._.merge({
    max: 9999999999.99,
    precision: 2
  }, _vm.curEditData.fieldProps || {}), false)) : _c(_vm.curEditData.valueType, _vm._b({
    tag: "component",
    staticStyle: {
      width: "100%"
    },
    model: {
      value: _vm.editForm[_vm.curEditData.dataIndex],
      callback: function ($$v) {
        _vm.$set(_vm.editForm, _vm.curEditData.dataIndex, $$v);
      },
      expression: "editForm[curEditData.dataIndex]"
    }
  }, "component", _vm.curEditData.fieldProps, false))], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;